var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"dense":_vm.dense,"hide-details":_vm.hideDetails,"items":_vm.timeArrays,"label":_vm.$t(_vm.label),"menu-props":{offsetY:true},"rules":_vm.rules,"item-text":"start","item-value":"start","outlined":""},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }